import { Fragment, Key, ReactNode } from 'react';
import { cn } from 'utils/cn';
import StepConnectorStyled from './StepConnectorStyled';

export type StepperStep = {
    key: Key;
    /** Not reached yet: the connector leading into it is grey. */
    disabled?: boolean;
    node: ReactNode;
};

/** Steps stacked vertically, a connector line between each step and the one before it. */
export default function StepperStyled({ steps, className }: { steps: StepperStep[]; className?: string }) {
    return (
        <div className={cn('flex flex-col', className)}>
            {steps.map((step, index) => (
                <Fragment key={step.key}>
                    {index > 0 ? <StepConnectorStyled disabled={step.disabled} /> : null}
                    <div>{step.node}</div>
                </Fragment>
            ))}
        </div>
    );
}
